import React, { useEffect, useState } from "react";
import style from "../Invoice.module.scss";
import { MyModal } from "../../../../utility";
import ModalContainer from "../../../../components/modal_popup";
import { useSelector } from "react-redux";
import {
  TextField,
  Button,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
} from "@mui/material";
import { useDispatch } from "react-redux";
import { InvoiceDataFilterAction } from "../../../../redux-store/store";
import { AiOutlineClose } from "react-icons/ai";
import { BiFilterAlt } from "react-icons/bi";
import { FaExclamationTriangle } from "react-icons/fa";

function InvoiceTableFilter() {
  const InvoiceData = useSelector(
    (state) => state.InvoiceDataDetails.InvoiceDataFilter
  );
  const invoiceRedDot = useSelector(
    (state) => state.InvoiceDataDetails.refreshRedDot
  );
  const size = useSelector(
    (state) => state.InvoiceDataDetails.InvoiceDataFilter.size
  );
  const dispatch = useDispatch();
  const [showAlert, setShowAlert] = useState(false);
  const [formData, setFormData] = useState({
    invoiceNumber: InvoiceData.invoiceNumber || "",
    companyName: InvoiceData.companyName || "",
    startDate: InvoiceData.startDate || "",
    endDate: InvoiceData.endDate || "",
    paymentStatus: InvoiceData.paymentStatus || "",
    category: InvoiceData.category || "",
  });
  const [openFilter, setOpenFilter] = useState(false);

  // Handle input changes
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };
  useEffect(() => {}, [formData]);
  // Handle Submit
  const handleSubmit = () => {
    if (
      (formData.startDate != "" && formData.endDate === "") ||
      (formData.startDate === "" && formData.endDate != "")
    ) {
      setShowAlert(true);
      setTimeout(() => {
        setShowAlert(false);
      }, 2000);
      return;
    }
    dispatch(
      InvoiceDataFilterAction.setInvoiceDataFilter({
        ...formData,
        page: 1,
        size: size,
      })
    );
    dispatch(InvoiceDataFilterAction.setInvoicePage(1));
    if (
      formData.companyName != "" ||
      formData.startDate != "" ||
      formData.endDate != "" ||
      formData.invoiceNumber != "" ||
      formData.paymentStatus != "" ||
      formData.category != ""
    ) {
      dispatch(InvoiceDataFilterAction.setInvoiceRedDot(true));
    }
    setOpenFilter(false);

    // console.log("Filter Data Submitted:", formData);
  };

  // Handle Clear
  const handleClear = () => {
    setFormData({
      companyName: "",
      invoiceNumber: "",
      paymentStatus: "",
      category: "",
      startDate: "",
      endDate: "",
    });
    dispatch(InvoiceDataFilterAction.setInvoiceRedDot(false));
  };

  return (
    <div>
      <button
        className="btn d-flex align-items-center"
        style={{ backgroundColor: "#169c50", color: "#fff" }}
        onClick={() => setOpenFilter(true)}
      >
        <BiFilterAlt />{" "}
        <p
          style={{
            backgroundColor: invoiceRedDot ? "#d83f49" : "transparent",
            width: "8px",
            height: "8px",
            borderRadius: "50%",
          }}
        ></p>
        Filter{" "}
      </button>

      {openFilter && (
        <MyModal>
          <ModalContainer
            childComponent={
              <>
                <div className={style.filterContainer}>
                  <div className="d-flex align-items-center justify-content-between">
                    <div>
                      <h6>Filter Invoices</h6>
                    </div>
                    <div
                      className="btn btn-danger"
                      onClick={() => {
                        setOpenFilter(false);
                      }}
                    >
                      <AiOutlineClose />
                    </div>
                  </div>

                  <FormControl fullWidth margin="normal">
                    <TextField
                      label="Invoice Number"
                      name="invoiceNumber"
                      value={formData.invoiceNumber}
                      onChange={handleInputChange}
                      variant="outlined"
                    />
                  </FormControl>
                  <FormControl fullWidth margin="normal">
                    <TextField
                      label="Company Name"
                      name="companyName"
                      value={formData.companyName}
                      onChange={handleInputChange}
                      variant="outlined"
                    />
                  </FormControl>

                  <div className="row">
                    <div className="col-sm-6">
                      <FormControl fullWidth margin="normal">
                        <TextField
                          label="Invoice Start Date"
                          name="startDate"
                          type="date"
                          value={formData.startDate}
                          onChange={handleInputChange}
                          InputLabelProps={{
                            shrink: true,
                          }}
                          variant="outlined"
                        />
                      </FormControl>
                    </div>
                    <div className="col-sm-6">
                      <FormControl fullWidth margin="normal">
                        <TextField
                          label="Invoice End Date"
                          name="endDate"
                          type="date"
                          value={formData.endDate}
                          onChange={handleInputChange}
                          InputLabelProps={{
                            shrink: true,
                          }}
                          variant="outlined"
                        />
                      </FormControl>
                    </div>
                  </div>

                  <FormControl fullWidth margin="normal">
                    <InputLabel>Payment Status</InputLabel>
                    <Select
                      label="Payment Status"
                      name="paymentStatus"
                      value={formData.paymentStatus}
                      onChange={handleInputChange}
                    >
                      <MenuItem value="Pending">Email sent / pending</MenuItem>
                      <MenuItem value="Cancelled">Cancelled</MenuItem>
                      <MenuItem value="Received">Received</MenuItem>
                    </Select>
                  </FormControl>
                  <FormControl fullWidth margin="normal">
                    <InputLabel>Category</InputLabel>
                    <Select
                      label="Category"
                      name="category"
                      value={formData.category || "Recruitment Service"}
                      onChange={handleInputChange}
                    >
                      <MenuItem value="">All</MenuItem>
                      <MenuItem value="Recruitment Service">
                        Recruitment Service
                      </MenuItem>
                      <MenuItem value="IT Service">IT Service</MenuItem>
                    </Select>
                  </FormControl>

                  {showAlert && (
                    <div className="d-flex justify-content-center">
                      <div
                        className="alert alert-warning d-flex align-items-center w-100"
                        role="alert"
                      >
                        <div>
                          <FaExclamationTriangle />
                        </div>
                        <div
                          className={`ms-2 mt-1`}
                          style={{ fontSize: "13px" }}
                        >
                          Select Date Range
                        </div>
                      </div>
                    </div>
                  )}
                  <div className={style.buttonContainer}>
                    <button className="btn btn-danger" onClick={handleClear}>
                      Clear
                    </button>
                    <button className="btn btn-success" onClick={handleSubmit}>
                      Submit
                    </button>
                  </div>
                </div>
              </>
            }
          />
        </MyModal>
      )}
      {/* {showAlert && (
        <MyModal>
          <ModalContainer
            zIndex={1004}
            childComponent={
              <>
                <div className="p-1" style={{ width: "150px" }}>
                  {" "}
                  <div>Select date range</div>
                  <div className="d-flex justify-content-end mt-1">
                    <div
                      className="btn btn-success px-3"
                      onClick={() => {
                        setShowAlert(false);
                      }}
                    >
                      Ok
                    </div>
                  </div>
                </div>
              </>
            }
          />
        </MyModal>
      )} */}
    </div>
  );
}

export default InvoiceTableFilter;
